// Temporarily disabled - under maintenance
// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { getAllTickets, getTicketStats, Ticket, PaginationData, TicketStats } from '../../services/ticketService';
// import { toast } from 'react-toastify';

import React from 'react';

const AdminTickets: React.FC = () => {
  // Temporarily disabled - under maintenance
  // const [tickets, setTickets] = useState<Ticket[]>([]);
  // const [loading, setLoading] = useState(true);
  // const [statsLoading, setStatsLoading] = useState(true);
  // const [stats, setStats] = useState<TicketStats | null>(null);
  // const [pagination, setPagination] = useState<PaginationData>({
  //   currentPage: 1,
  //   totalPages: 1,
  //   totalItems: 0,
  //   hasNextPage: false,
  //   hasPrevPage: false
  // });

  // // Filters
  // const [filters, setFilters] = useState({
  //   status: '',
  //   department: '',
  //   priority: '',
  //   page: 1
  // });

  // // Filter options
  // const statusOptions = [
  //   { value: '', label: 'همه وضعیت‌ها' },
  //   { value: 'open', label: 'باز' },
  //   { value: 'in_progress', label: 'در حال انجام' },
  //   { value: 'waiting_user', label: 'در انتظار پاسخ کاربر' },
  //   { value: 'waiting_admin', label: 'در انتظار پاسخ ادمین' },
  //   { value: 'resolved', label: 'حل شده' },
  //   { value: 'closed', label: 'بسته شده' }
  // ];

  // const departmentOptions = [
  //   { value: '', label: 'همه بخش‌ها' },
  //   { value: 'IT', label: 'IT' },
  //   { value: 'reception', label: 'پذیرشگر' },
  //   { value: 'financial', label: 'حسابدار' },
  //   { value: 'support', label: 'جوابدهی' }
  // ];

  // const priorityOptions = [
  //   { value: '', label: 'همه اولویت‌ها' },
  //   { value: 'low', label: 'کم' },
  //   { value: 'medium', label: 'متوسط' },
  //   { value: 'high', label: 'زیاد' },
  //   { value: 'urgent', label: 'فوری' }
  // ];

  // // Fetch tickets
  // const fetchTickets = async () => {
  //   try {
  //     setLoading(true);
      
  //     const params = {
  //       page: filters.page,
  //       limit: 15,
  //       ...(filters.status && { status: filters.status }),
  //       ...(filters.department && { department: filters.department }),
  //       ...(filters.priority && { priority: filters.priority })
  //     };

  //     const response = await getAllTickets(params);

  //     if (response.success && response.data.tickets && response.data.pagination) {
  //       setTickets(response.data.tickets);
  //       setPagination(response.data.pagination);
  //     }
  //   } catch (error) {

  //     toast.error('خطا در دریافت تیکت‌ها');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // // Fetch stats
  // const fetchStats = async () => {
  //   try {
  //     setStatsLoading(true);
  //     const response = await getTicketStats();
      
  //     if (response.success && response.data) {
  //       setStats(response.data);
  //     }
  //   } catch (error) {

  //   } finally {
  //     setStatsLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchTickets();
  // }, [filters]);

  // useEffect(() => {
  //   fetchStats();
  // }, []);

  // // Handle filter changes
  // const handleFilterChange = (name: string, value: string) => {
  //   setFilters(prev => ({
  //     ...prev,
  //     [name]: value,
  //     page: 1 // Reset to first page when filters change
  //   }));
  // };

  // // Handle page change
  // const handlePageChange = (newPage: number) => {
  //   setFilters(prev => ({
  //     ...prev,
  //     page: newPage
  //   }));
  // };

  // // Get status badge color
  // const getStatusBadgeColor = (status: string) => {
  //   switch (status) {
  //     case 'open':
  //       return 'bg-blue-100 text-blue-800';
  //     case 'in_progress':
  //       return 'bg-yellow-100 text-yellow-800';
  //     case 'waiting_user':
  //       return 'bg-orange-100 text-orange-800';
  //     case 'waiting_admin':
  //       return 'bg-purple-100 text-purple-800';
  //     case 'resolved':
  //       return 'bg-green-100 text-green-800';
  //     case 'closed':
  //       return 'bg-gray-100 text-gray-800';
  //     default:
  //       return 'bg-gray-100 text-gray-800';
  //   }
  // };

  // // Get priority badge color
  // const getPriorityBadgeColor = (priority: string) => {
  //   switch (priority) {
  //     case 'urgent':
  //       return 'bg-red-100 text-red-800';
  //     case 'high':
  //       return 'bg-orange-100 text-orange-800';
  //     case 'medium':
  //       return 'bg-yellow-100 text-yellow-800';
  //     case 'low':
  //       return 'bg-gray-100 text-gray-800';
  //     default:
  //       return 'bg-gray-100 text-gray-800';
  //   }
  // };

  // // Format date
  // const formatDate = (dateString: string) => {
  //   return new Intl.DateTimeFormat('fa-IR', {
  //     year: 'numeric',
  //     month: 'long',
  //     day: 'numeric',
  //     hour: '2-digit',
  //     minute: '2-digit'
  //   }).format(new Date(dateString));
  // };

  return (
    <div className="p-4 md:p-6">
      <div className="bg-white rounded-lg shadow-md border border-gray-200 p-8">
        <div className="text-center">
          <div className="text-6xl mb-4">🔧</div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">در حال تعمیر</h1>
          <p className="text-lg text-gray-600 mb-2">
            بخش مدیریت تیکت‌ها در حال تعمیر و به‌روزرسانی است
          </p>
          <p className="text-sm text-gray-500">
            لطفاً در زمان دیگری مراجعه کنید
          </p>
        </div>
      </div>
    </div>
  );

  // Original code - temporarily commented out
  // return (
  //   <div className="p-4 md:p-6">
  //     {/* Header */}
  //     <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
  //       <div>
  //         <h1 className="text-2xl font-bold text-gray-900 mb-2">مدیریت تیکت‌ها</h1>
  //         <p className="text-gray-600">
  //           مشاهده، پاسخ و مدیریت تمام تیکت‌های سیستم پشتیبانی
  //         </p>
  //       </div>
  //       <button
  //         onClick={() => {
  //           fetchTickets();
  //           fetchStats();
  //         }}
  //         className="mt-4 sm:mt-0 inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
  //       >
  //         <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
  //         </svg>
  //         بروزرسانی
  //       </button>
  //     </div>

  //     {/* Statistics */}
  //     {!statsLoading && stats && (
  //       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
  //         <div className="bg-white rounded-lg shadow-md border border-gray-200 p-4">
  //           <div className="flex items-center">
  //             <div className="flex-shrink-0">
  //               <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
  //                 <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
  //                   <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
  //                 </svg>
  //               </div>
  //             </div>
  //             <div className="mr-4">
  //               <p className="text-sm font-medium text-gray-600">کل تیکت‌ها</p>
  //               <p className="text-2xl font-semibold text-gray-900">{stats.total}</p>
  //             </div>
  //           </div>
  //         </div>

  //         <div className="bg-white rounded-lg shadow-md border border-gray-200 p-4">
  //           <div className="flex items-center">
  //             <div className="flex-shrink-0">
  //               <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
  //                 <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
  //                   <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
  //                 </svg>
  //               </div>
  //             </div>
  //             <div className="mr-4">
  //               <p className="text-sm font-medium text-gray-600">باز</p>
  //               <p className="text-2xl font-semibold text-blue-600">{stats.open}</p>
  //             </div>
  //           </div>
  //         </div>

  //         <div className="bg-white rounded-lg shadow-md border border-gray-200 p-4">
  //           <div className="flex items-center">
  //             <div className="flex-shrink-0">
  //               <div className="w-8 h-8 bg-yellow-100 rounded-lg flex items-center justify-center">
  //                 <svg className="w-4 h-4 text-yellow-600" fill="currentColor" viewBox="0 0 20 20">
  //                   <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
  //                 </svg>
  //               </div>
  //             </div>
  //             <div className="mr-4">
  //               <p className="text-sm font-medium text-gray-600">در حال انجام</p>
  //               <p className="text-2xl font-semibold text-yellow-600">{stats.inProgress}</p>
  //             </div>
  //           </div>
  //         </div>

  //         <div className="bg-white rounded-lg shadow-md border border-gray-200 p-4">
  //           <div className="flex items-center">
  //             <div className="flex-shrink-0">
  //               <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center">
  //                 <svg className="w-4 h-4 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
  //                   <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clipRule="evenodd" />
  //                 </svg>
  //               </div>
  //             </div>
  //             <div className="mr-4">
  //               <p className="text-sm font-medium text-gray-600">در انتظار ادمین</p>
  //               <p className="text-2xl font-semibold text-purple-600">{stats.waitingAdmin}</p>
  //             </div>
  //           </div>
  //         </div>

  //         <div className="bg-white rounded-lg shadow-md border border-gray-200 p-4">
  //           <div className="flex items-center">
  //             <div className="flex-shrink-0">
  //               <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center">
  //                 <svg className="w-4 h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20">
  //                   <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
  //                 </svg>
  //               </div>
  //             </div>
  //             <div className="mr-4">
  //               <p className="text-sm font-medium text-gray-600">حل شده</p>
  //               <p className="text-2xl font-semibold text-green-600">{stats.resolved}</p>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     )}

  //     {/* Filters */}
  //     <div className="bg-white rounded-lg shadow-md border border-gray-200 mb-6">
  //       <div className="p-4">
  //         <h3 className="text-lg font-medium text-gray-900 mb-4">فیلترها</h3>
  //         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
  //           <div>
  //             <label className="block text-sm font-medium text-gray-700 mb-1">
  //               وضعیت
  //             </label>
  //             <select
  //               value={filters.status}
  //               onChange={(e) => handleFilterChange('status', e.target.value)}
  //               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
  //             >
  //               {statusOptions.map(option => (
  //                 <option key={option.value} value={option.value}>
  //                   {option.label}
  //                 </option>
  //               ))}
  //             </select>
  //           </div>

  //           <div>
  //             <label className="block text-sm font-medium text-gray-700 mb-1">
  //               بخش
  //             </label>
  //             <select
  //               value={filters.department}
  //               onChange={(e) => handleFilterChange('department', e.target.value)}
  //               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
  //             >
  //               {departmentOptions.map(option => (
  //                 <option key={option.value} value={option.value}>
  //                   {option.label}
  //                 </option>
  //               ))}
  //             </select>
  //           </div>

  //           <div>
  //             <label className="block text-sm font-medium text-gray-700 mb-1">
  //               اولویت
  //             </label>
  //             <select
  //               value={filters.priority}
  //               onChange={(e) => handleFilterChange('priority', e.target.value)}
  //               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
  //             >
  //               {priorityOptions.map(option => (
  //                 <option key={option.value} value={option.value}>
  //                   {option.label}
  //                 </option>
  //               ))}
  //             </select>
  //           </div>
  //         </div>
  //       </div>
  //     </div>

  //     {/* Tickets List */}
  //     <div className="bg-white rounded-lg shadow-md border border-gray-200">
  //       {loading ? (
  //         <div className="p-8 text-center">
  //           <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
  //           <p className="mt-2 text-gray-600">در حال بارگذاری...</p>
  //         </div>
  //       ) : tickets.length === 0 ? (
  //         <div className="p-8 text-center">
  //           <div className="text-gray-400 text-6xl mb-4">🎧</div>
  //           <h3 className="text-lg font-medium text-gray-900 mb-2">
  //             هیچ تیکتی یافت نشد
  //           </h3>
  //           <p className="text-gray-600">
  //             بر اساس فیلترهای انتخاب شده، تیکتی در سیستم موجود نیست
  //           </p>
  //         </div>
  //       ) : (
  //         <>
  //           {/* Tickets Table */}
  //           <div className="overflow-x-auto">
  //             <table className="min-w-full divide-y divide-gray-200">
  //               <thead className="bg-gray-50">
  //                 <tr>
  //                   <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //                     شناسه
  //                   </th>
  //                   <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //                     عنوان
  //                   </th>
  //                   <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //                     کاربر
  //                   </th>
  //                   <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //                     بخش
  //                   </th>
  //                   <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //                     اولویت
  //                   </th>
  //                   <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //                     وضعیت
  //                   </th>
  //                   <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //                     آخرین فعالیت
  //                   </th>
  //                   <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //                     عملیات
  //                   </th>
  //                 </tr>
  //               </thead>
  //               <tbody className="bg-white divide-y divide-gray-200">
  //                 {tickets.map((ticket) => (
  //                   <tr key={ticket._id} className="hover:bg-gray-50">
  //                     <td className="px-6 py-4 whitespace-nowrap">
  //                       <div className="flex items-center">
  //                         <div className="text-sm font-medium text-gray-900">
  //                           {ticket.displayId || ticket._id.slice(-8)}
  //                         </div>
  //                         {ticket.unreadCount && ticket.unreadCount > 0 && (
  //                           <span className="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
  //                             {ticket.unreadCount}
  //                           </span>
  //                         )}
  //                       </div>
  //                     </td>
  //                     <td className="px-6 py-4">
  //                       <div className="text-sm font-medium text-gray-900">
  //                         {ticket.title}
  //                       </div>
  //                       <div className="text-sm text-gray-500">
  //                         {ticket.ticketNumber}
  //                       </div>
  //                     </td>
  //                     <td className="px-6 py-4 whitespace-nowrap">
  //                       <div className="text-sm text-gray-900">
  //                         {ticket.userId.name} {ticket.userId.lastName}
  //                       </div>
  //                       <div className="text-sm text-gray-500">
  //                         {ticket.userId.mobile}
  //                       </div>
  //                     </td>
  //                     <td className="px-6 py-4 whitespace-nowrap">
  //                       <div className="text-sm text-gray-900">
  //                         {ticket.departmentDisplay}
  //                       </div>
  //                     </td>
  //                     <td className="px-6 py-4 whitespace-nowrap">
  //                       <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getPriorityBadgeColor(ticket.priority)}`}>
  //                         {ticket.priorityDisplay}
  //                       </span>
  //                     </td>
  //                     <td className="px-6 py-4 whitespace-nowrap">
  //                       <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusBadgeColor(ticket.status)}`}>
  //                         {ticket.statusDisplay}
  //                       </span>
  //                     </td>
  //                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
  //                       {formatDate(ticket.lastActivity)}
  //                     </td>
  //                     <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
  //                       <Link
  //                         to={`/admin/tickets/${ticket._id}`}
  //                         className="text-blue-600 hover:text-blue-900 ml-4"
  //                       >
  //                         مدیریت
  //                       </Link>
  //                     </td>
  //                   </tr>
  //                 ))}
  //               </tbody>
  //             </table>
  //           </div>

  //           {/* Pagination */}
  //           {pagination.totalPages > 1 && (
  //             <div className="px-6 py-3 border-t border-gray-200">
  //               <div className="flex items-center justify-between">
  //                 <div className="text-sm text-gray-700">
  //                   نمایش {((pagination.currentPage - 1) * 15) + 1} تا {Math.min(pagination.currentPage * 15, pagination.totalItems)} از {pagination.totalItems} نتیجه
  //                 </div>
  //                 <div className="flex space-x-1 space-x-reverse">
  //                   <button
  //                     onClick={() => handlePageChange(pagination.currentPage - 1)}
  //                     disabled={!pagination.hasPrevPage}
  //                     className="px-3 py-1 text-sm border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
  //                   >
  //                     قبلی
  //                   </button>
  //                   <span className="px-3 py-1 text-sm text-gray-700">
  //                     صفحه {pagination.currentPage} از {pagination.totalPages}
  //                   </span>
  //                   <button
  //                     onClick={() => handlePageChange(pagination.currentPage + 1)}
  //                     disabled={!pagination.hasNextPage}
  //                     className="px-3 py-1 text-sm border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
  //                   >
  //                     بعدی
  //                   </button>
  //                 </div>
  //               </div>
  //             </div>
  //           )}
  //         </>
  //       )}
  //     </div>
  //   </div>
  // );
};

export default AdminTickets;